import { ALL_ESTADOS, LOADING_ALL_ESTADOS } from './EstadosReducer';
import { allEstadosService } from './EstadosService';

export const allEstadosAction = async (dispatch, pais) => {
  dispatch({ type: LOADING_ALL_ESTADOS, payload: true });
  try {
    const res = await allEstadosService({ pais });
    if (res.status === 200) {
      dispatch({
        type: ALL_ESTADOS,
        payload: res.data,
      });
      dispatch({ type: LOADING_ALL_ESTADOS, payload: false });
      return true;
    }
  } catch (e) {
    console.log(e.message);
    dispatch({ type: LOADING_ALL_ESTADOS, payload: false });
  }
};
